<template>

    <div v-if="album">

        <div class="album-name">
            {{ album.name }}
        </div>

        <div class="album-tracks-count text-stardust-grey">
            {{ album.trackcount }} Tracks.
        </div>


        <div class="form-group">

            <label for="projectFromEmailInput">
                Sender Email:
            </label>

            <input class="form-control" id="projectFromEmailInput" placeholder="me@example.com" v-model="fromEmail" />

        </div>

        <div class="form-group">

            <label for="projectToEmailInput">
                Recipient Email (max. 3, comma-separated):
            </label>

            <input class="form-control" id="projectToEmailInput" placeholder="them@example.com" v-model="email" />

        </div>

		 <div class="form-group">

            <label for="emailNotesInput">
                Album Notes:
            </label>

            <textarea class="form-control" id="emailNotesInput" placeholder="Email Notes (optional)" v-model="notes" cols="30" rows="7" />

        </div>

        <a class="btn btn-raised btn-xl font-weight-semibold share-button" v-bind:class="{ 'btn-success': sharing, 'btn-danger': !sharing }" href="#" v-on:click.prevent="emailAlbum">
            <span v-if="!sharing">Share</span>
            <span v-if="sharing"><img src="/images/download-spinner.gif" alt="spinner" class="loading-icon">Sharing...</span>
        </a>

        <div class="form-group row">
            <div class="col-12">


                <label><br/><br/> <strong>Or</strong> share using the URL below</label>

                <textarea v-model="copiedAlbumDetails" id="albumData" class="d-none"></textarea></div>
            <div class="col-sm-10">
                <input class="form-control" type="text" :value="copiedAlbumDetails" readonly />
            </div>
            <div class="col-sm-2 copy-album">
                <a href="#" class="btn btn-primary btn-block btn-sm copy-album-details-button" v-bind:class="{ 'btn-success': copied }"
                   data-clipboard-action="copy" data-clipboard-target="#albumData">
                    <span v-if="!copied">Copy</span>
                    <span v-if="copied">Copied</span>
                </a>
            </div>
        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
    import Clipboard from 'clipboard';
	import { playerService } from '../player-service';

	export default Vue.component(
	  'share-album',
	  {

		  data: function () {

			  return {

				  album: null,
				  notes: null,
				  email: null,
                  fromEmail: window.authenticatedUserEmail ? window.authenticatedUserEmail : '',
                  copiedAlbumDetails: null,
                  clipboardPlugin: null,
                  copied: false,
                  sharing: false

			  };

		  },

		  mounted: function () {

              let ctx = this;

              playerService.$on( 'user-updated', () => {
                  this.fromEmail = window.authenticatedUserEmail ? window.authenticatedUserEmail : '';
              } );

              // Change the edit album contents depending on whats passed to it.
			  playerService.$on(
				'share-album',
				( album ) => {

					// Update curr track for modal.
					this.album = album;

			  		this.reset();

					// Open the modal.
					window.webpackOpenBsModalWorkaround( '#shareAlbumModal' );

                    // Setup the contents of the textarea.
                    this.copiedAlbumDetails = this.getWindowUrl() + '/player?view-album=' + this.album.id;


                    if (this.clipboardPlugin) {
                        this.clipboardPlugin.destroy();
                    }

                    this.clipboardPlugin = new Clipboard('.copy-album-details-button', {
                        container: document.getElementById('shareAlbumModal'),
                        text: function (trigger) {
                            return ctx.copiedAlbumDetails
                        }
                    });

                    this.copied = false;

                    this.sharing = false;

                    this.clipboardPlugin.on('success', function (e) {

                        ctx.copied = true;

                        e.clearSelection();
                    });

                    if(this.fromEmail) {
                        setTimeout(function() {
                            $('#projectFromEmailInput').attr('readonly', true);
                        }, 250);
                    }

				}
			  );

		  },

		  methods: {

		  	emailAlbum: function() {

                this.sharing = true;

				playerService.emailAlbum( this.album, this.email, this.notes, this.fromEmail );

            },

		  	reset: function() {

				this.notes = null;
				this.email = null;

            },

            copy: function () {

                this.copied = true;

            },


            getWindowUrl: function () {
                if (!window.location.origin) {
                    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                }

                return window.location.origin;

            },

		  },

		  watch: {

			  album: function( value ) {
				  this.reset();
			  }

		  }

	  }
	);

</script>
